
import React from 'react';
import { ArrowRight } from 'lucide-react';
import CTAButton from './CTAButton';
import { useBreakpoint } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';

const FinalCTA = () => {
  const { isMobile } = useBreakpoint();
  
  return (
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-[#003a70] mb-4 md:mb-6">
        Start Building with AskSpot Today.
      </h2>
      
      <p className="text-sm md:text-lg lg:text-xl text-brand-gray max-w-2xl mx-auto mb-8 md:mb-12">
        Get started for free and see how AskSpot can automate and optimize your business—no coding required.
      </p>
      
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
        {/* Primary CTA Button */}
        <CTAButton 
          to="/pricing"
          variant="primary" 
          className="w-full sm:w-auto group"
        >
          <span className="flex items-center justify-center whitespace-nowrap">
            Start Your 30-Day Free Trial
            <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </span>
        </CTAButton>
        
        {/* Secondary CTA Button - Now with Link to book-demo */}
        <Link to="/book-demo">
          <button 
            className="w-full sm:w-auto py-3 px-5 rounded-full font-medium transition-all duration-300 border-2 border-[#FEE6D8] text-[#003a70] hover:bg-[#FEE6D8]/20 group flex items-center justify-center btn-hover-effect"
          >
            <span className="flex items-center justify-center whitespace-nowrap relative z-10">
              Book a Demo
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default FinalCTA;
